import React from 'react';
import config from '../../config';

function rawMarkup(text) {
  return { __html: text };
}

function PromotionTnCContainer({
  termsAndConditions,
}) {
  const logo = `${config.s3BucketUrl}/stores/${config.storeCode}/${config.storeCode}.png`;

  return (
    <div className='container my-3'>
      <div className='row justify-content-center'>
        <div className='col-md-10'>
          <img src={logo} className='' style={{ maxWidth: '150px' }} />
          <hr/>
          <div className='contents' dangerouslySetInnerHTML={rawMarkup(termsAndConditions)}/>
        </div>
      </div>
    </div>
  );
}

export default PromotionTnCContainer;



// WEBPACK FOOTER //
// ./src/Promotion/PromotionTnCContainer.js